import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import styles from '@/pages/nms/login/style/index.module.less';
import { setLocale } from 'di18n-react';
import loginPng from '@/assets/login.png';
import React, { useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import LoginForm from '@/pages/nms/login/LoginForm';
import RegisterForm from '@/pages/nms/login/RegisterForm';
import IconButton from '@/components/NavBar/IconButton';
import { GlobalContext } from '@/context';
export default function LoginLayout() {
  const {
    path
  } = useRouteMatch();
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  function changeLang(key) {
    setLocale(key, {
      cookieLocaleKey: 'lang'
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.banner
  }, /*#__PURE__*/React.createElement("img", {
    src: loginPng,
    alt: "login"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute right-14 top-2"
  }, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: [{
      label: '中文',
      value: 'zh-CN'
    }, {
      label: 'English',
      value: 'en-US'
    }],
    getPopupContainer: t => t?.parentElement,
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      changeLang(value);
      // Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: path,
    component: LoginForm
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${path}/register`,
    component: RegisterForm
  })))));
}